// const API = {
//   API_BASE_URL: 'https://pluraldev.pinepg.in',
//   API_AUTH_URL: 'https://pluraldev.pinepg.in',
//   SETTLEMENT_API_BASE_URL: 'https://pluraldev.pinepg.in',
//   SETTLEMENT_API_AUTH_URL: 'https://pluraldev.pinepg.in',
//   API_PAYOUTS_URL: 'https://3.108.151.44:9443',
//   API_SALESFORCE_URL: 'https://pinelabs--pluraldel.sandbox.my.salesforce.com',
//   API_SALESFORCE_AUTH_URL: 'https://pinelabs--pluraldel.sandbox.my.salesforce.com',
//   API_CASE_MANAGEMENT_URL:'https://supporttest.pinelabs.com/pluralqa',
//   API_SIGNZY_URL: 'https://preproduction.signzy.tech',
//   API_VERIFY_KYC_URL: 'http://192.168.103.45:8081',
// };
const API = {
  API_BASE_URL: 'https://pluralqa.pluralonline.com',
  API_AUTH_URL: 'https://pluralqa.pluralonline.com',
  SETTLEMENT_API_BASE_URL: 'https://pluralqa.pluralonline.com',
  SETTLEMENT_API_AUTH_URL: 'https://pluralqa.pluralonline.com',
  API_PAYOUTS_URL: 'https://pluralqa.pluralonline.com',
  API_SALESFORCE_URL: 'https://pinelabs--pluralqa.sandbox.my.salesforce.com',
  API_SALESFORCE_AUTH_URL:
    'https://pinelabs--pluralqa.sandbox.my.salesforce.com',
  API_CASE_MANAGEMENT_URL: 'https://supporttest.pinelabs.com/pluralqa',
  API_SIGNZY_URL: 'https://preproduction.signzy.tech',
  API_VERIFY_KYC_URL: 'https://pluralqa.pluralonline.com',
  API_WEBHOOK_KEY: 'xPjkgEv+sI4kCL1DxH2TEg==',
};

export default {
  API,
};
